import React from 'react';

const CardContent = ({ title, description }) => {

    return (
        <div style={{marginBottom: '20px'}}>
            <span style={{ fontSize: '11px', fontWeight: 'bold' }}>{title}</span>
            <br />
            {description}
        </div>
    )
}

export default CardContent